/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{margin-bottom:30px}.news-panel-item__link[_ngcontent-%COMP%]{display:block;color:var(--text-color);text-decoration:none}.news-panel-item__image[_ngcontent-%COMP%]{margin-bottom:12px}.news-panel-item__title[_ngcontent-%COMP%]{font-weight:600;font-size:20px;margin-bottom:10px}.news-panel-item__date[_ngcontent-%COMP%]{font-size:13px;margin-bottom:12px}.news-panel-item__descr[_ngcontent-%COMP%]{line-height:20px;max-height:calc(20px * 3);overflow:hidden}"];
export { styles as styles };
